import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { ListTableComponent } from '@ppl/ui';
import { ButtonComponent } from '@ppl/ui';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { CommonModule } from '@angular/common';
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TimesheetFilterComponent } from "../timesheet-filter/timesheet-filter.component";
import { TimesheetService } from '../../../../services/timesheet.service';
import { ListService } from '../../../../shared/services/list.service';
import { TimesheetDetailViewComponent } from "../timesheet-detail-view/timesheet-detail-view.component";
import { LookupService } from '../../../../services/lookup.service';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { PDFFormConfig } from '../../../../interfaces/config';
import { HttpResponse } from '@angular/common/http';
import { EditpdfComponent } from '../../../editpdf/editpdf.component';
import { UserService } from '../../../../services/user.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { PAGE_CONSTANTS, PAGE_AVAILABLE_ACTIONS } from '../../../../shared/constants/page.constants';
import { AuthorizeButtonDirective } from '../../../../shared/authorization/authorizeButton.directive';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'ppl-timesheet-staff-list',
  standalone: true,
  imports: [ListTableComponent, ButtonComponent, NgZorroModule, CommonModule,
    TimesheetNewEntriesComponent, TimesheetFilterComponent, TimesheetDetailViewComponent, EditpdfComponent, AuthorizeButtonDirective],
  templateUrl: './timesheet-staff-list.component.html',
  styleUrl: './timesheet-staff-list.component.css',
})
export class TimesheetStaffListComponent {
  pageId: string = PAGE_CONSTANTS.STAFF_TIMESHEETS;

  @ViewChild('timesheetDialog') timesheetDialog!: TemplateRef<any>;
  @ViewChild('timesheetViewDialog') timesheetViewDialog!: TemplateRef<any>;
  @ViewChild('timeoffViewDialog') timeoffViewDialog!: TemplateRef<any>;
  @ViewChild('pdfDialog') pdfDialogRef!: TemplateRef<any>;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;

  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;

  private dialogSvc = inject(DialogService);
  actionButtons: TableRowActionsModel = new TableRowActions({ view: false });
  appliedFilters: any;
  selectedRow: any;
  viewDialogId: any;
  addDialogId: any;
  timeOffData: any;
  isViewTimeOff = false;
  statusList: any;
  modalBody = {
    pdfViewer: ''
  };
  processingStatusList: any;
  excludeList = ['serviceDuration', 'payrollStartDate', 'payrollEndDate', 'payrollId', 'providerId', 'headerId', 'tasMasterPayrollScheduleId', 'serviceDate'];
  chequeNumbers: any[] = [];
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;

  cols = [
    {
      field: 'payPeriod',
      header: 'Pay Period',
      jsonpath: 'payPeriod',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerName',
      header: 'Provider Name',
      jsonpath: 'providerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'providerPplId',
      header: 'Provider PPL ID',
      jsonpath: 'providerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'grossAmount',
      header: 'Gross Amount',
      jsonpath: 'grossAmount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paymentDate',
      header: 'Payment Date',
      jsonpath: 'paymentDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'chequeAmount',
      header: 'Check Amount',
      jsonpath: 'chequeAmount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'chequeNumber',
      header: 'Check Number',
      jsonpath: 'chequeNumber',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  lineItemCols = [
    {
      field: 'consumerName',
      header: 'Participant Name',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'y',
    },
    {
      field: 'consumerPplId',
      header: 'Participant PPL ID',
      jsonpath: 'consumerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'servicePeriodDesc',
      header: 'Service Period',
      jsonpath: 'servicePeriodDesc',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'totalLines',
      header: 'Total Lines',
      jsonpath: 'totalLines',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidLines',
      header: 'Paid Lines',
      jsonpath: 'paidLines',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'pendedLines',
      header: 'Pending Lines',
      jsonpath: 'pendedLines',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'deniedLines',
      header: 'Denied Lines',
      jsonpath: 'deniedLines',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'notSubmitted',
      header: 'Not Submitted Lines',
      jsonpath: 'notSubmitted',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'inProgress',
      header: 'Review Lines',
      jsonpath: 'inProgress',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'readyForPayment',
      header: 'Ready For Payment Lines',
      jsonpath: 'readyForPayment',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  programName!: string;
  payPeriod: any[] = [];
  timesheets: any[] = [];
  hasSearched = false;
  selectedLineItem!: any;
  selectedRowData!: any;
  pdfConfig?: PDFFormConfig;
  pdfFile?: string;
  pdfBlob?: Blob;
  showModal = false;
  isReadOnly = false;

  constructor(private listService: ListService,
    private timesheetService: TimesheetService,
    private lookupService: LookupService,
    private userService: UserService,
    private dateTimeFormatter: DateTimeFormatterService,
    private allowListStore: AllowListAuthStore) { }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.statusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.setPageAccess();
  }

  private setPageAccess() {
    const pageConfig = this.allowListStore.getConfig()?.pages[this.pageId];
    if (pageConfig) {
      const availableActions = PAGE_AVAILABLE_ACTIONS[this.pageId] ?? [];
      const allowedActions = this.allowListStore.getAllowedActions(this.pageId);
      this.actionsToBeHidden = availableActions.filter(
        action => !allowedActions.some(aa => aa.toLowerCase() === action.toLowerCase())
      );
      const allowedButtons = this.allowListStore.getAllowedButtons(this.pageId);
      this.isReadOnly = allowedActions.length === 0 && allowedButtons.length === 0;
    } else {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }

  loadRecordsAfterUpdate() {
    let filters = this.appliedFilters;
    if (!this.appliedFilters || this.appliedFilters.length == 0) {
      filters = [];
      filters.push({
        jsonPath: "serviceDuration",
        value: '30 days',
        operator: "lessThan"
      });
    }

    this.searchTimesheets(filters, undefined, undefined, false, this.childComponent?.recordsPerPage ?? 20);
  }

  buildRequestPayload(pageName: string, orderBy: string, searchParams: [], startingPageNumber = 1, recordsPerPage = 20) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: recordsPerPage,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchTimesheets(filters: any, startingPageNumber = 1, currentPage = 0, isChequeLookUp = false, recordsPerPage = 20) {
    this.hasSearched = true;
    const processedPayload = this.buildRequestPayload(
      'stafftimesheetlist',
      'tasMasterPayrollScheduleId',
      filters,
      startingPageNumber,
      recordsPerPage
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processData(data.responsedata);

        if (isChequeLookUp) {
          if (records && records?.length) {
            this.chequeNumbers = Array.from(
              new Set(records.filter((e: any) => e.chequeNumber).map((e: any) => e.chequeNumber)));
          }
        }
        else {
          // De-dupe the merged set, not just this page, so cross-page duplicate
          // payroll rows are caught.
          if (startingPageNumber > 1) {
            this.timesheets = this.processData([...this.timesheets, ...(data.responsedata ?? [])]);
          } else {
            this.timesheets = records;
          }
          if (this.timesheets?.length) {
            this.chequeNumbers = Array.from(
              new Set(this.timesheets.filter((e: any) => e.chequeNumber).map((e: any) => e.chequeNumber)));
          }
        }
      });
  }

  onNewTimesheet() {
    this.openAddPopup();
  }

  handleCancel() {
    this.selectedRowData = undefined;
    this.selectedLineItem = undefined;
    this.showModal = false;
    this.pdfConfig = undefined;
    this.pdfFile = undefined;
  }

  processData(data: any) {
    if (data && data.length > 0) {

      data.forEach((element: any) => {
        element.payPeriod = element.payrollStartDate + ' - ' + element.payrollEndDate
      });

      return data;
    }

    return data;
  }

  onPageLoad(event: any) {
    this.searchTimesheets(this.appliedFilters, event.startingPageNumber, event?.first ?? 0, false, event.rows ?? 20);
  }

  getFilters(event: any) {
    const filters = [];
    filters.push({
      jsonPath: "serviceDuration",
      value: event.Timeframe ? event.Timeframe : '30 days',
      operator: "lessThan"
    });

    if (event.providerName && event.providerName.trim()) {
      filters.push({
        jsonPath: "providerName",
        value: event.provider.trim(),
        operator: "Equal"
      });
    }

    if (event.consumer && event.consumer.trim()) {
      filters.push({
        jsonPath: "consumerName",
        value: event.consumer.trim(),
        operator: "Equal"
      });
    }

    if (event.provider && event.provider.trim()) {
      filters.push({
        jsonPath: "providerName",
        value: event.provider.trim(),
        operator: "Equal"
      });
    }

    if (event.providerPplId && event.providerPplId.trim()) {
      filters.push({
        jsonPath: "providerPplId",
        value: event.providerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.consumerPplId && event.consumerPplId.trim()) {
      filters.push({
        jsonPath: "consumerPplId",
        value: event.consumerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.chequeNumber && event.chequeNumber.length) {
      filters.push({
        jsonPath: "chequeNumber",
        values: Array.isArray(event.chequeNumber) ? event.chequeNumber : [event.chequeNumber],
        operator: "In"
      });
    }


    if (event.status) {
      filters.push({
        jsonPath: "businessStatus",
        value: event.status,
        operator: "Equal"
      });
    }

    if (event.servicePeriod) {
      filters.push(
        { 
          jsonPath: 'servicePeriodId',
          value: event.servicePeriod,
          operator: 'Equal' 
        });
    }

    if (event.payPeriod) {
      filters.push({
        jsonPath: "tasMasterPayrollScheduleId",
        value: event.payPeriod,
        operator: "Equal"
      });
    }

    if (event.processStatusLkp) {
      filters.push({
        jsonPath: "processStatusLkp",
        value: event.processStatusLkp,
        operator: "Equal"
      });
    }

    if (event.serviceCode) {
      filters.push({
        jsonPath: "serviceCode",
        value: event.serviceCode,
        operator: "Equal"
      });
    }

    if (event.serviceDate) {
      filters.push({
        jsonPath: "serviceDate",
        value: this.dateTimeFormatter.formatDateToString(event.serviceDate as Date),
        operator: "Equal"
      });
    }

    return filters;
  }

  onSearch(event: any) {
    const filters = this.getFilters(event);

    const hasRelevantFilter = filters.some(filter =>
      ["providerName", "consumerName", "providerPplId", "consumerPplId"].includes(filter.jsonPath)
    );

    if (!hasRelevantFilter && environment.requireAtleastOneUserFilter) {
      this.openConfirmationPopup();
      return;
    }

    this.appliedFilters = filters;
    this.searchTimesheets(filters, undefined, undefined, event.chequeLookUp, this.childComponent?.recordsPerPage ?? 20);
  }

  onExport(_event: any) {
    if (!this.timesheets || this.timesheets.length === 0) {
      return;
    }

    const ids = [...new Set(this.timesheets.map((r: any) => Number(r.tasMasterPayrollScheduleId)))];
    const headerIds = [...new Set(this.timesheets.map((r: any) => Number(r.headerId)))];
    const filters: any = (this.appliedFilters || []).filter((f: any) => f.jsonPath !== 'serviceDuration');
    filters.push({
      jsonPath: 'id',
      values: ids,
      operator: 'In'
    });

    filters.push({
      jsonPath: 'headerId',
      values: headerIds,
      operator: 'In'
    });

    const processedPayload = this.buildRequestPayload(
      'stafftimesheetByConsumerExportList',
      'masterPayrollScheduleId',
      filters,
      1,
      20
    );
    processedPayload.export = true;
    processedPayload.exportType = 'xlsx';
    this.listService
      .newListPage(processedPayload, `Timesheets_Export_${new Date().toISOString()}.xlsx`, true)
      .subscribe((data: any) => {
      });
  }

  openConfirmationPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Error',
      showOkButton: true,
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  onAction(event: any) {
    if (event.action === 'view') {
      this.selectedRowData = event.param;
      this.selectedLineItem = event.data;
      this.onView();
    }

    if (event.action === 'timeoff') {
      this.onViewTimeOff(event.data);
    }
  }

  onViewTimeOff(data: any) {
    this.selectedLineItem = data;
    const timeOffPayload: any = [{
      jsonPath: "providerId",
      value: data.providerId,
      operator: "Equal"
    },
    {
      jsonPath: "tasMasterPayrollScheduleId",
      value: data.tasMasterPayrollScheduleId,
      operator: "Equal"
    }
    ];
    const processedPayload = this.buildRequestPayload(
      'staffTimeOffEntry',
      '',
      timeOffPayload
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const response = data.responsedata;
        response.forEach((e: any) => {
          const businessStatus = this.statusList.find((gen: LookupValueItem) => {
            return gen.lkpValueCode === e.businessStatusLkp;
          });

          if (businessStatus) {
            e.businessStatus = businessStatus.lkpValueName;
          }

          const processingStatus = this.processingStatusList.find((gen: LookupValueItem) => {
            return gen.lkpValueCode === e.processingStatusLkp;
          });

          if (processingStatus) {
            e.processingStatus = processingStatus.lkpValueName;
          }
        });

        response.sort((a: any, b: any) => {
          const dateA = new Date(a.serviceDate);
          const dateB = new Date(b.serviceDate);

          // Check if the dates are valid before performing comparison
          if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
            return 0; // If invalid dates, no sorting occurs
          }

          return dateA.getTime() - dateB.getTime(); // Sort by date in ascending order
        });

        this.timeOffData = response;
        this.viewTimeOff();
      });
  }

  onView() {
    this.openViewPopup();
  }

  rowClicked(event: any) {
    if (event.loaded) {
      event.showLineItem = !event.showLineItem;
      return;
    }

    const subRowFilter = this.appliedFilters.filter((e: any) => !this.excludeList.includes(e.jsonPath));
    subRowFilter.push({
      jsonPath: "payrollId",
      value: event.tasMasterPayrollScheduleId,
      operator: "Equal"
    });

    subRowFilter.push({
      jsonPath: "providerId",
      value: event.providerId,
      operator: "Equal"
    });

    subRowFilter.push({
      jsonPath: "headerId",
      value: event.headerId,
      operator: "Equal"
    });

    this.selectedRow = event;
    this.getStaffTimesheetSubrow(subRowFilter, event);
  }

  getStaffTimesheetSubrow(filters: any, event: any) {
    const processedPayload = this.buildRequestPayload(
      'stafftimesheetByConsumerList',
      'masterPayrollScheduleId',
      filters
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        event.lineItems = data.responsedata;
        event.lineItems.forEach((element: any) => {
          element.servicePeriodDesc = element.serviceStartDate + ' - ' + element.serviceEndDate
        });

        event.lineItems.sort((a: any, b: any) => {
          const dateA = new Date(a.serviceStartDate);
          const dateB = new Date(b.serviceStartDate);
          return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
        });
        event.showLineItem = true;
        event.loaded = true;
      });
  }

  onProcessComplete(event: any) {
    if (this.viewDialogId) {
      this.dialogSvc.closeDialog(this.viewDialogId);
      this.viewDialogId = null;
    }

    this.loadRecordsAfterUpdate();
  }

  openAddPopup() {
    if (this.addDialogId) {
      console.log('[TimesheetStaffList] openAddPopup: dialog already opened', this.addDialogId);
      return;
    }
    const dialogConfig: DialogConfig = {
      title: 'Add New Time Entries',
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.addDialogId = this.dialogSvc.openDialog(
      this.timesheetDialog,
      dialogConfig,
      () => { this.handleCancel(); this.addDialogId = null; },
      () => { this.handleCancel(); this.addDialogId = null; }
    );
  }


  openViewPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Timesheet',
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.viewDialogId = this.dialogSvc.openDialog(
      this.timesheetViewDialog,
      dialogConfig,
      () => { this.handleCancel(); this.viewDialogId = null; },
      () => { this.handleCancel(); this.viewDialogId = null; }
    );
  }

  timesheetAdded(event: any) {
    if (event.timesheetAdded) {
      this.closeAddDialog();
      this.loadRecordsAfterUpdate();
    }
  }

  closeAddDialog() {
    if (this.addDialogId) {
      this.dialogSvc.closeDialog(this.addDialogId);
      this.addDialogId = null;
    }
  }

  viewTimeOff() {
    console.log('view timeoff');
    this.isViewTimeOff = true;
    const dialogConfig: DialogConfig = {
      title: 'View Time Off',
      okText: 'Ok',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.viewDialogId = this.dialogSvc.openDialog(
      this.timeoffViewDialog,
      dialogConfig,
      () => { this.handleCancel(); this.viewDialogId = null; },
      () => { this.handleCancel(); this.viewDialogId = null; }
    );
  }

  onRowActions(event: any) {
   if(event.type === 'download' ){
      this.timesheetService.downloadPaystub(event, this.programName);
    }
    else{
      this.viewPaystub(event, this.programName);
    }
  }

  viewPaystub(event: any, programCode: string) {
    this.showModal = true;
    this.modalBody.pdfViewer = 'Paystub';

    this.pdfConfig = {
      form_id: '',
      is_mandatory: false,
      form_description: '',
      form_name: '',
      fields: []
    };

    const dialogConfig: DialogConfig = {
      title: this.modalBody.pdfViewer,
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    }

    this.dialogSvc.openDialog(this.pdfDialogRef, dialogConfig, () => this.handleCancel(), () => this.handleCancel());

    this.getPaystub(event.event.checkId, event.event.chequeNumber, event.event.providerPplId, this.programName);
  }

  getPaystub(checkId: string, chequeNumber: string, empId: string, programCode: string) {
    this.timesheetService.getPayStub(checkId, chequeNumber, empId, programCode).subscribe((response: HttpResponse<Blob>) => {
      if (response.body) {
        const blob = new Blob([response.body], { type: response.body.type });
        this.pdfBlob = blob;
        this.pdfFile = window.URL.createObjectURL(blob);
      }
    });
  }

  onViewUserClicked = (payload: any) => {
    // Emit event through UserService to trigger the home component to open the user details dialog
    // The home component subscribes to viewUserEvent and handles opening the appropriate dialog
    this.userService.setViewUserEvent({
      userId: payload.userId,
      isConsumer: payload.isConsumer
    });
  }
}
